import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { Topic } from '@/component'

import styles from './sectionItem.module.scss'

function SectionItem(props) {
  const { topic, children } = props
  return (
    <div className={styles.wrapper}>
      <Topic title={topic} />
      <>
        {children}
      </>
    </div>
  )
}

SectionItem.propTypes = {
  topic: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
  ]).isRequired,
}

SectionItem.defaultProps = {
  topic: '',
}

export default memo(SectionItem)
